<template>
  <div>
    <h1 class="page-title" @click="back">{{ $t('message.news.back') }}</h1>
    <div style="padding: 0px 16px 16px 16px" class="ql-container ql-editor">
      <div v-html="detail"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  data() {
    return {
      detail: '',
    }
  },
  mounted() {
    this.fetchTableData()
  },
  methods: {
    async fetchTableData() {
      console.log(this.$route)
      const id = this.$route.query.id
      try {
        const response = await axios({
          url: `${this.$url.memo.url_render_detail}?recId=${id}`, // 你的真实接口地址
          method: 'get',
        })
        console.log(response)
        if (response.data.code === 200) {
          this.detail = response.data.data
        } else {
          this.$message.error('Failed to fetch tender details')
        }
      } catch (error) {
        console.error('Error fetching tender details:', error)
        this.$message.error('An error occurred while fetching tender details')
      }
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped>
.page-title {
  font-size: 2.5rem;
  color: #1f2937;
  margin: 16px 0 16px 16px;
  font-weight: 600;
}
.page-title:hover {
  cursor: pointer;
}
</style>
